import emailjs from "emailjs-com";

const sendEmail = (templateParams: {}) => {
  emailjs
    .send(
      "service_qxhp8g6",
      "template_sj9u64n",
      templateParams,
      "9D2pr5qQ3W2yJwH_p"
    )
    .then((response) => {
      console.log("email send successfully", response.status, response.text);
    })
    .catch((error) => {
      console.error("upp error", error);
    });
};
export default sendEmail;
